export default __webpack_public_path__ + "4ecef75fc4f4bcc09601735b8bceb57c.mp3";